import guestsJson from './guests.json'
import orderTypeJson from './order-type.json'

/*
 * Synthetic demonstration fixtures only. These are not customers, production
 * data, an API response, or a backend schema.
 */

export type CellTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

export type GuestCell = {
  primary: string
  secondary?: string
  tone?: CellTone
}

export type GuestRow = {
  id: string
  label: string
  detail?: { title: string; description: string }
  cells: {
    name: GuestCell
    party: GuestCell
    time: GuestCell
    production: GuestCell
    membership: GuestCell
    message: GuestCell
  }
}

export type GuestColumn = {
  key: keyof GuestRow['cells']
  labelKey: string
  sortable?: boolean
  width: string
}

export const guestsFixture = guestsJson as unknown as {
  viewTotals: Record<string, number>
  columns: GuestColumn[]
  rows: GuestRow[]
}

export const orderTypeFixture = orderTypeJson as unknown as {
  identity: { id: string; displayName: string }
  contentLanguages: { label: string; value: string }[]
  values: {
    displayName: string
    enabled: boolean
    orderingCloses: number
    maxOrders: number
    maxItems: number
    reachedMessage: string
    minimumSpend: number
    menuTitle: string
    outletRouting: string
    fallbackOutlet: string
    paymentRequired: boolean
    depositPercent: number
    audience: string
    collectionEnabled: boolean
    collectionInstructions: string
  }
  /** Guest-facing values in content languages other than English, by language. */
  translations: Record<string, { displayName: string; reachedMessage: string }>
  options: {
    outlets: { label: string; value: string }[]
    audiences: { label: string; value: string }[]
    outletRouting: string[]
  }
}
